import useIsMobile from "@/hooks/useIsMobile";
import LandingPage from "@/screens/MPbaithaki";
import dynamic from "next/dynamic";
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function Category({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,

  electionLiveData = null,
  photosData = null,
  storyData = null,
  videoData = null,
}) {
  const isMobileDevice = useIsMobile();
  
  return (
    <>
      <PageLayout
        rightSideBarData={categoryNewsListData}
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
        electionLiveData={electionLiveData}
      >
        <LandingPage
          categoryNewsList={categoryNewsListData}
          electionLiveData={electionLiveData}
          photoData={photosData}
          storyData={storyData}
          videoData={videoData}
          isMobileDevice={isMobileDevice}
        />
      </PageLayout>
    </>
  );
}

export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  // const isMpbaithakiRoute = ctx.resolvedUrl.startsWith("/mahya-pradesh/baithaki");
  // if (!isMpbaithakiRoute) {
  //   return { notFound: true };
  // }
  try {
    let url = ctx?.resolvedUrl;
    //* remove query param from url
    url = url.split("?")[0];
    const { getFaqBySlug } = await import("@/handlers/faq");
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const { getElectionVideoData } = await import("@/handlers/liveVideo");
    const unixtime = getUnixTimeDaysAgo(15);
    let masterConfigData = await getMasterConfig();

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api

    let storyListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "story",
      },
    });
    let videoListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "video",
      },
    });
    let photoListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: page,
        display: 12,
        type: "photo_gallery",
      },
    });

    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });

    let electionLiveRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: { api: "staticconfig", id: "home_livetv_config" },
    });
    let [
      categoryNewsListData,
      photosData,
      storyData,
      videoData,
      latestStoryData,
      latestVideoData,
      //   faqData,
      electionLiveData,
    ] = await Promise.all([
      null,
      fetchRedisWrapper(photoListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: page,
          display: 12,
          type: "photo_gallery",
        })
      ),
      fetchRedisWrapper(storyListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: page,
          display: 12,
          type: "story",
        })
      ),
      fetchRedisWrapper(videoListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: page,
          display: 12,
          type: "video",
        })
      ),

      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),

      fetchRedisWrapper(electionLiveRedisKey, () => getElectionVideoData()),
    ]);

    let headerCache = storyData?.cache;
    setPageTTL(ctx, headerCache?.akamai_ttl);
    // console.log("mp data",   videoData);
    return {
      props: {
        categoryNewsListData,
        photosData,
        storyData,
        videoData,
        latestStoryData,
        latestVideoData,

        electionLiveData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
